"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendTokenMethodEnum = void 0;
var SendTokenMethodEnum;
(function (SendTokenMethodEnum) {
    // Поступит звонок
    SendTokenMethodEnum["CALL"] = "CALL";
    // Самостоятельно позвонить и ввести 6-ти значный код
    SendTokenMethodEnum["SELF_CALL"] = "SELF_CALL";
    // Отправка PUSH в мобильное приложение
    SendTokenMethodEnum["PUSH"] = "PUSH";
    // Отправка СМС
    SendTokenMethodEnum["SMS"] = "SMS";
})(SendTokenMethodEnum = exports.SendTokenMethodEnum || (exports.SendTokenMethodEnum = {}));
//# sourceMappingURL=SendTokenMethodEnum.js.map